var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71 7.13a5.89 5.89 0 0 1 5.88-5.88 5.89 5.89 0 0 1 5.88 5.88 5.89 5.89 0 0 1-5.88 5.88 5.89 5.89 0 0 1-5.88-5.88zm1.5 0c0 2.42 1.96 4.38 4.38 4.38s4.38-1.96 4.38-4.38S18 2.75 15.59 2.75s-4.38 1.96-4.38 4.38zM2.531 16.36c0-2.11 1.72-3.83 3.83-3.83 2.11 0 3.83 1.72 3.83 3.83 0 2.11-1.72 3.83-3.83 3.83-2.11 0-3.83-1.72-3.83-3.83zm1.5 0c0 1.28 1.04 2.33 2.33 2.33 1.28 0 2.33-1.04 2.33-2.33 0-1.28-1.05-2.33-2.33-2.33s-2.33 1.04-2.33 2.33zM13.31 19.44c0-1.83 1.49-3.31 3.31-3.31a3.32 3.32 0 0 1 3.31 3.31 3.32 3.32 0 0 1-3.31 3.31c-1.83 0-3.31-1.49-3.31-3.31zm1.5-.01a1.81 1.81 0 1 0 3.62 0 1.81 1.81 0 0 0-3.62 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBubble);
export default __webpack_public_path__ + "static/media/vuesax-outline-bubble.05d1dd79c124973b9635f96a8ba398f3.svg";
export { ForwardRef as ReactComponent };